import {CAMPAIGN_MESSAGE_CONTENT_TYPE} from 'Pages/apps/default/projectPages/campaign/const';

/** @typedef {string} CustomerListFileError */
export const CUSTOMER_LIST_FILE_ERROR_MISSING_VALUE = 'MISSING_VALUE';
export const CUSTOMER_LIST_FILE_ERROR_NOT_FOUND_IN_DB = 'NOT_FOUND_IN_DB';
export const CUSTOMER_LIST_FILE_ERROR_INVALID_VALUE = 'INVALID_VALUE';
export const CUSTOMER_LIST_FILE_ERROR_ALREADY_EXISTS_VALUE = 'ALREADY_EXISTS_VALUE';
export const CUSTOMER_LIST_FILE_ERROR_DUPLICATED_VALUE = 'DUPLICATED_VALUE';
/** @enum {CustomerListFileError} */
export const CUSTOMER_LIST_FILE_ERROR = {
	MISSING_VALUE: CUSTOMER_LIST_FILE_ERROR_MISSING_VALUE,
	NOT_FOUND_IN_DB: CUSTOMER_LIST_FILE_ERROR_NOT_FOUND_IN_DB,
	INVALID_VALUE: CUSTOMER_LIST_FILE_ERROR_INVALID_VALUE,
	ALREADY_EXISTS_VALUE: CUSTOMER_LIST_FILE_ERROR_ALREADY_EXISTS_VALUE,
	DUPLICATED_VALUE: CUSTOMER_LIST_FILE_ERROR_DUPLICATED_VALUE,
};
/** @type {CustomerListFileError[]} */
export const CUSTOMER_LIST_FILE_ERRORS = [
	CUSTOMER_LIST_FILE_ERROR_MISSING_VALUE,
	CUSTOMER_LIST_FILE_ERROR_NOT_FOUND_IN_DB,
	CUSTOMER_LIST_FILE_ERROR_INVALID_VALUE,
	CUSTOMER_LIST_FILE_ERROR_ALREADY_EXISTS_VALUE,
	CUSTOMER_LIST_FILE_ERROR_DUPLICATED_VALUE,
];

// Hardcoded customer fields
/** @typedef {string} CustomerField */
export const CUSTOMER_FIELD_FIRST_NAME = 'FIRST NAME';
export const CUSTOMER_FIELD_LAST_NAME = 'LAST NAME';
export const CUSTOMER_FIELD_EMAIL = 'EMAIL';
export const CUSTOMER_FIELD_PHONE_NUMBER = 'PHONE NUMBER';
export const CUSTOMER_FIELD_EXTERNAL_CRM_ID = 'EXTERNAL CRM ID';
export const CUSTOMER_FIELD_DATE_OF_BIRTH = 'DATE OF BIRTH';
export const CUSTOMER_FIELD_BIRTHDAY = 'BIRTHDAY';
/** @enum {CustomerField} */
export const CUSTOMER_FIELD = {
	FIRST_NAME: CUSTOMER_FIELD_FIRST_NAME,
	LAST_NAME: CUSTOMER_FIELD_LAST_NAME,
	EMAIL: CUSTOMER_FIELD_EMAIL,
	PHONE_NUMBER: CUSTOMER_FIELD_PHONE_NUMBER,
	EXTERNAL_CRM_ID: CUSTOMER_FIELD_EXTERNAL_CRM_ID,
	DATE_OF_BIRTH: CUSTOMER_FIELD_DATE_OF_BIRTH,
	BIRTHDAY: CUSTOMER_FIELD_BIRTHDAY,
};
/** @type {CustomerField[]} */
export const CUSTOMER_FIELDS = [
	CUSTOMER_FIELD_FIRST_NAME,
	CUSTOMER_FIELD_LAST_NAME,
	CUSTOMER_FIELD_EMAIL,
	CUSTOMER_FIELD_PHONE_NUMBER,
	CUSTOMER_FIELD_EXTERNAL_CRM_ID,
	CUSTOMER_FIELD_DATE_OF_BIRTH,
	CUSTOMER_FIELD_BIRTHDAY,
];

/** @typedef {string} CustomerMessageStatus */
export const CUSTOMER_MESSAGE_STATUS_IN_PREPARATION = 'IN_PREPARATION';
export const CUSTOMER_MESSAGE_STATUS_PENDING = 'PENDING';
export const CUSTOMER_MESSAGE_STATUS_QUEUED = 'QUEUED';
export const CUSTOMER_MESSAGE_STATUS_WAITING_FOR_DELIVERY = 'WAITING_FOR_DELIVERY';
export const CUSTOMER_MESSAGE_STATUS_DELIVERED = 'DELIVERED';
export const CUSTOMER_MESSAGE_STATUS_UNDELIVERABLE = 'UNDELIVERABLE';
export const CUSTOMER_MESSAGE_STATUS_EXPIRED = 'EXPIRED';
export const CUSTOMER_MESSAGE_STATUS_REJECTED = 'REJECTED';
export const CUSTOMER_MESSAGE_STATUS_ERROR = 'ERROR';
export const CUSTOMER_MESSAGE_STATUS_DUPLICATE = 'DUPLICATE';
export const CUSTOMER_MESSAGE_STATUS_NOT_TRIED = 'NOT_TRIED';
export const CUSTOMER_MESSAGE_STATUS_LINK_OPENED = 'LINK_OPENED';
export const CUSTOMER_MESSAGE_STATUS_MISSING_TO = 'MISSING_TO';
export const CUSTOMER_MESSAGE_STATUS_BLOCKED = 'BLOCKED';
export const CUSTOMER_MESSAGE_STATUS_BLOCKED_BY_CAPPING_PLAN = 'BLOCKED_BY_CAPPING_PLAN';
export const CUSTOMER_MESSAGE_STATUS_BLACKLISTED = 'BLACKLISTED';
export const CUSTOMER_MESSAGE_STATUS_OPENED = 'OPENED';
export const CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_MISSING = 'EXTERNAL_ID_MISSING';
export const CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_DUPLICATE = 'EXTERNAL_ID_DUPLICATE';
export const CUSTOMER_MESSAGE_STATUS_FAILED = 'FAILED';
export const CUSTOMER_MESSAGE_STATUS_API_IO_ERROR = 'API_IO_ERROR';
export const CUSTOMER_MESSAGE_STATUS_UNKNOWN = 'UNKNOWN';
/** @enum {CustomerMessageStatus} */
export const CUSTOMER_MESSAGE_STATUS = {
	IN_PREPARATION: CUSTOMER_MESSAGE_STATUS_IN_PREPARATION,
	PENDING: CUSTOMER_MESSAGE_STATUS_PENDING,
	QUEUED: CUSTOMER_MESSAGE_STATUS_QUEUED,
	WAITING_FOR_DELIVERY: CUSTOMER_MESSAGE_STATUS_WAITING_FOR_DELIVERY,
	DELIVERED: CUSTOMER_MESSAGE_STATUS_DELIVERED,
	UNDELIVERABLE: CUSTOMER_MESSAGE_STATUS_UNDELIVERABLE,
	EXPIRED: CUSTOMER_MESSAGE_STATUS_EXPIRED,
	REJECTED: CUSTOMER_MESSAGE_STATUS_REJECTED,
	ERROR: CUSTOMER_MESSAGE_STATUS_ERROR,
	DUPLICATE: CUSTOMER_MESSAGE_STATUS_DUPLICATE,
	NOT_TRIED: CUSTOMER_MESSAGE_STATUS_NOT_TRIED,
	LINK_OPENED: CUSTOMER_MESSAGE_STATUS_LINK_OPENED,
	MISSING_TO: CUSTOMER_MESSAGE_STATUS_MISSING_TO,
	BLOCKED: CUSTOMER_MESSAGE_STATUS_BLOCKED,
	BLOCKED_BY_CAPPING_PLAN: CUSTOMER_MESSAGE_STATUS_BLOCKED_BY_CAPPING_PLAN,
	BLACKLISTED: CUSTOMER_MESSAGE_STATUS_BLACKLISTED,
	OPENED: CUSTOMER_MESSAGE_STATUS_OPENED,
	EXTERNAL_ID_MISSING: CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_MISSING,
	EXTERNAL_ID_DUPLICATE: CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_DUPLICATE,
	FAILED: CUSTOMER_MESSAGE_STATUS_FAILED,
	API_IO_ERROR: CUSTOMER_MESSAGE_STATUS_API_IO_ERROR,
	UNKNOWN: CUSTOMER_MESSAGE_STATUS_UNKNOWN,
};
/** @type {CustomerMessageStatus[]} */
export const CUSTOMER_MESSAGE_STATUSES = [
	CUSTOMER_MESSAGE_STATUS_IN_PREPARATION,
	CUSTOMER_MESSAGE_STATUS_PENDING,
	CUSTOMER_MESSAGE_STATUS_QUEUED,
	CUSTOMER_MESSAGE_STATUS_WAITING_FOR_DELIVERY,
	CUSTOMER_MESSAGE_STATUS_DELIVERED,
	CUSTOMER_MESSAGE_STATUS_UNDELIVERABLE,
	CUSTOMER_MESSAGE_STATUS_EXPIRED,
	CUSTOMER_MESSAGE_STATUS_REJECTED,
	CUSTOMER_MESSAGE_STATUS_ERROR,
	CUSTOMER_MESSAGE_STATUS_DUPLICATE,
	CUSTOMER_MESSAGE_STATUS_NOT_TRIED,
	CUSTOMER_MESSAGE_STATUS_MISSING_TO,
	CUSTOMER_MESSAGE_STATUS_OPENED,
	CUSTOMER_MESSAGE_STATUS_LINK_OPENED,
	CUSTOMER_MESSAGE_STATUS_BLOCKED,
	CUSTOMER_MESSAGE_STATUS_BLOCKED_BY_CAPPING_PLAN,
	CUSTOMER_MESSAGE_STATUS_BLACKLISTED,
	CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_MISSING,
	CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_DUPLICATE,
	CUSTOMER_MESSAGE_STATUS_FAILED,
	CUSTOMER_MESSAGE_STATUS_API_IO_ERROR,
	CUSTOMER_MESSAGE_STATUS_UNKNOWN,
];
/** @type {Object<CustomerMessageStatus, string>} */
export const CUSTOMER_MESSAGE_STATUS_CLASS_MAP = {
	[CUSTOMER_MESSAGE_STATUS_IN_PREPARATION]: 'default',
	[CUSTOMER_MESSAGE_STATUS_PENDING]: 'default',
	[CUSTOMER_MESSAGE_STATUS_QUEUED]: 'default',
	[CUSTOMER_MESSAGE_STATUS_WAITING_FOR_DELIVERY]: 'success',
	[CUSTOMER_MESSAGE_STATUS_DELIVERED]: 'success',
	[CUSTOMER_MESSAGE_STATUS_UNDELIVERABLE]: 'error',
	[CUSTOMER_MESSAGE_STATUS_EXPIRED]: 'error',
	[CUSTOMER_MESSAGE_STATUS_REJECTED]: 'error',
	[CUSTOMER_MESSAGE_STATUS_ERROR]: 'error',
	[CUSTOMER_MESSAGE_STATUS_DUPLICATE]: 'error',
	[CUSTOMER_MESSAGE_STATUS_NOT_TRIED]: 'default',
	[CUSTOMER_MESSAGE_STATUS_LINK_OPENED]: 'success',
	[CUSTOMER_MESSAGE_STATUS_MISSING_TO]: 'error',
	[CUSTOMER_MESSAGE_STATUS_BLOCKED]: 'error',
	[CUSTOMER_MESSAGE_STATUS_BLACKLISTED]: 'error',
	[CUSTOMER_MESSAGE_STATUS_OPENED]: 'success',
	[CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_MISSING]: 'error',
	[CUSTOMER_MESSAGE_STATUS_EXTERNAL_ID_DUPLICATE]: 'error',
	[CUSTOMER_MESSAGE_STATUS_FAILED]: 'error',
	[CUSTOMER_MESSAGE_STATUS_API_IO_ERROR]: 'error',
	[CUSTOMER_MESSAGE_STATUS_UNKNOWN]: 'default',
};

/** @typedef {string} CustomerMessageSubStatus */
export const CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SEEN = 'VIBER_SEEN';
export const CUSTOMER_MESSAGE_SUB_STATUS_VIBER_DELIVERED = 'VIBER_DELIVERED';
export const CUSTOMER_MESSAGE_SUB_STATUS_VIBER_BAD_DATA = 'VIBER_BAD_DATA';
export const CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SWIPED = 'VIBER_SWIPED';
export const CUSTOMER_MESSAGE_SUB_STATUS_VIBER_RECEIVED = 'VIBER_RECEIVED';
export const CUSTOMER_MESSAGE_SUB_STATUS_PUSH_DELIVERED = 'PUSH_DELIVERED';
export const CUSTOMER_MESSAGE_SUB_STATUS_PUSH_OPENED = 'PUSH_OPENED';
export const CUSTOMER_MESSAGE_SUB_STATUS_PUSH_SWIPED = 'PUSH_SWIPED';
/** @enum {CustomerMessageSubStatus} */
export const CUSTOMER_MESSAGE_SUB_STATUS = {
	VIBER_SEEN: CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SEEN,
	VIBER_DELIVERED: CUSTOMER_MESSAGE_SUB_STATUS_VIBER_DELIVERED,
	VIBER_BAD_DATA: CUSTOMER_MESSAGE_SUB_STATUS_VIBER_BAD_DATA,
	VIBER_SWIPED: CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SWIPED,
	VIBER_RECEIVED: CUSTOMER_MESSAGE_SUB_STATUS_VIBER_RECEIVED,
	PUSH_DELIVERED: CUSTOMER_MESSAGE_SUB_STATUS_PUSH_DELIVERED,
	PUSH_OPENED: CUSTOMER_MESSAGE_SUB_STATUS_PUSH_OPENED,
	PUSH_SWIPED: CUSTOMER_MESSAGE_SUB_STATUS_PUSH_SWIPED,
};
/** @type {CustomerMessageSubStatus[]} */
export const CUSTOMER_MESSAGE_SUB_STATUSES = [
	CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SEEN,
	CUSTOMER_MESSAGE_SUB_STATUS_VIBER_DELIVERED,
	CUSTOMER_MESSAGE_SUB_STATUS_VIBER_BAD_DATA,
	CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SWIPED,
	CUSTOMER_MESSAGE_SUB_STATUS_VIBER_RECEIVED,
	CUSTOMER_MESSAGE_SUB_STATUS_PUSH_DELIVERED,
	CUSTOMER_MESSAGE_SUB_STATUS_PUSH_OPENED,
	CUSTOMER_MESSAGE_SUB_STATUS_PUSH_SWIPED,
];

export const CUSTOMER_MESSAGE_SUB_STATUS_BY_MESSAGE_TYPE = {
	[CAMPAIGN_MESSAGE_CONTENT_TYPE.VIBER]: [
		CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SEEN,
		CUSTOMER_MESSAGE_SUB_STATUS_VIBER_DELIVERED,
		CUSTOMER_MESSAGE_SUB_STATUS_VIBER_BAD_DATA,
		CUSTOMER_MESSAGE_SUB_STATUS_VIBER_SWIPED,
		CUSTOMER_MESSAGE_SUB_STATUS_VIBER_RECEIVED,
	],
	[CAMPAIGN_MESSAGE_CONTENT_TYPE.PUSH_NOTIFICATION]: [
		CUSTOMER_MESSAGE_SUB_STATUS_PUSH_DELIVERED,
		CUSTOMER_MESSAGE_SUB_STATUS_PUSH_OPENED,
		CUSTOMER_MESSAGE_SUB_STATUS_PUSH_SWIPED,
	],
};